export const EVIDENCE_LEVEL_COMPONENT_CODING = {
  system: 'http://loinc.org',
  code: '93044-6',
  display: 'Level of evidence',
};

export const NOTES_EXTENSION_URL =
  'http://hl7.org/fhir/uv/genomics-reporting/StructureDefinition/genomics-artifact';

export const TRIAL_ID_CODING = {
  system: 'http://loinc.org',
  code: '82786-5',
  display: 'Clinical trial identifier',
};
